import { Box, CircularProgress, Text } from '@streamelements/frontend-ui';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';
import { AllowedProvider } from '../../../constants/common';
import { providerIcons } from '../../../components/ProviderIcon';

const searchValidation = z.object({
  port: z.coerce.number(),
});

export const Route = createFileRoute('/auth/connect/$provider/callback')({
  component: () => <div></div>,
  pendingComponent: LoggingInInProgress,
  errorComponent: () => {
    return (
      <Box
        css={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
        }}
      >
        <Text.Heading level="3">The session has expired</Text.Heading>
        <Text.Body>Please try connecting your account again.</Text.Body>
      </Box>
    );
  },
  loaderDeps: ({ search }) => search,
  validateSearch: searchValidation,
  loader: async ({ params: { provider }, deps: { port }, context: { authContextProvider } }) => {
    // await new Promise((resolve) => setTimeout(resolve, 3000));

    const { channel, token } = await authContextProvider.getAuthContext();

    // const result = await fetch(`http://localhost:${port}/auth/connect/${provider}/callback`, {
    //   method: 'POST',
    //   body: JSON.stringify({
    //     channel,
    //   }),
    // });

    const messages = await Promise.allSettled([
      fetch(`http://localhost:${port}/auth/connect/${provider}/callback`, {
        method: 'POST',
        body: JSON.stringify({
          channel,
        }),
      }),
      fetch(`http://localhost:${port}/auth/connect/${provider}/token`, {
        method: 'POST',
        body: JSON.stringify({
          token,
        }),
      }),
    ]);

    if (messages.some((message) => message.status === 'rejected')) {
      redirect({
        to: '/auth/$provider/error',
        params: {
          provider,
        },
      });
    } else {
      redirect({
        to: '/auth/$provider/success',
        params: {
          provider,
        },
      });
    }
  },
});

function LoggingInInProgress() {
  const { provider } = Route.useParams();
  const Icon = providerIcons[provider as AllowedProvider];

  return (
    <Box
      css={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: '1rem',
        height: '100vh',
        textAlign: 'center',
      }}
    >
      <Box css={{ display: 'flex', alignItems: 'center', gap: '0.75rem' }}>
        <Box as="img" src="/logo.png" css={{ width: '3.25rem' }} />
        <CircularProgress.Root size={24} variant="indeterminate" value={25} />
        <Icon size="xl" css={{ '&&': { fontSize: '2.5rem' } }}></Icon>
      </Box>
      <Text.Heading level={5} css={{ m: 0 }} weight="bold">
        Logging you in...
      </Text.Heading>
      <Text.Body css={{ color: '$textPrimary70' }}>This shouldn't take long</Text.Body>
      <Text.Body css={{ color: '$textPrimary70' }}></Text.Body>
    </Box>
  );
}
